import { ReportGrammarRules } from '../../../../../../redux/config/customReport/types'
import {
  CustomReportCategory,
  CustomReportCategoryType
} from '../../../../../../redux/context/customReports/typesCategory'

// Enum definitions
export enum State {
  Root = 'root',
  Company = 'company',
  Dimension = 'dimension',
  PeriodGroup = 'periodGroup'
}

export enum ParameterMapping {
  Specific = 'specific',
  Agnostic = 'agnostic'
}

export type DropIndicator = {
  nodeId: string | null
  position: 'before' | 'after' | 'inside' | null
}

// Type for allowed parameter types in each context
export type ContextTypes = {
  [key in State]?: CustomReportCategoryType[][]
}

// Function definition with simplified parameter structure
export interface FunctionDefinition {
  types: ContextTypes
  mapping: ParameterMapping
  min: number
  max: number | null
}

// ----- VISITOR PATTERN IMPLEMENTATION -----

// Base TreeNode interface with unique ID for UI purposes
export interface BuilderNode extends CustomReportCategory {
  id: string
  expanded: boolean // UI state
  children: BuilderNode[]
  isDragging?: boolean
  dragProps?: {
    draggable: boolean
    onDragStart?: (e: React.DragEvent) => void
    onDragLeave: () => void
    onDragOver: (e: React.DragEvent) => void
    onDrop: (e: React.DragEvent) => void
    onDragEnd?: () => void
  }
  dragHandleProps?: {
    draggable: boolean
    onDragStart: (e: React.DragEvent) => void
    onDragEnd: (e: React.DragEvent) => void
  }
}

// Normalized version of BuilderNode for optimized state management
export interface NormalizedBuilderNode extends Omit<BuilderNode, 'children'> {
  parentId: string | null // Reference to parent node ID
  childIds: string[] // References to child node IDs
}

export type VisitorContext = {
  state: State
  company?: string
  dimension?: string
  isFunctionDecendant?: boolean
}

// First, create specialized node content components
export interface NodeContentProps {
  rules: ReportGrammarRules
  node: NormalizedBuilderNode
  context: VisitorContext
  onUpdateValue: (id: string, values: Partial<CustomReportCategory>) => void
}

// Type for the normalized tree state
export type NodesById = Record<string, NormalizedBuilderNode>

export interface NodeError {
  nodeId: string
  message: string
  messageParams?: Record<string, any>
}

export interface ErrorMap {
  [nodeId: string]: Array<NodeError>
}
